import { render, staticRenderFns } from "./PrizeCenter.vue?vue&type=template&id=37b2698d&scoped=true&"
import script from "./PrizeCenter.vue?vue&type=script&lang=js&"
export * from "./PrizeCenter.vue?vue&type=script&lang=js&"
import style0 from "./PrizeCenter.vue?vue&type=style&index=0&id=37b2698d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b2698d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b2698d')) {
      api.createRecord('37b2698d', component.options)
    } else {
      api.reload('37b2698d', component.options)
    }
    module.hot.accept("./PrizeCenter.vue?vue&type=template&id=37b2698d&scoped=true&", function () {
      api.rerender('37b2698d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/PrizeCenter.vue"
export default component.exports